var PhoneNumberVerificationView = (function (BaseView, InputFieldView) {
    return BaseView.extend({
        displayRoutes: ['checkout.phone.verification'],

        el: '@phoneVerification',

        events: {
            'click @verificationCodeResend': 'resendCode',
            'click @verificationCodeCheck': 'verifyCode'
        },

        initialize: function () {
            new InputFieldView({
                model: this.model.Phone,
                el: this.$el.find('@verificationPhoneInput')
            });

            new InputFieldView({
                model: this.model.VerificationCode,
                el: this.$el.find('@verificationCodeInput')
            });

            this.$codeErrorMessage = this.$el.find('@verificationCodeErrorMessage');
            this.$phoneErrorMessage = this.$el.find('@verificationPhoneErrorMessage');
            this.$countryCode = this.$el.find('@countryCode');

            this.listenTo(this.model, 'required', _.bind(function () {
                this.display('checkout.phone.verification');
            }, this));

            this.listenTo(this.model, 'change', _.bind(this.render, this));
        },

        verifyCode: function () {
            var that = this;
            this.model.checkVerificationCode()
                .done(function () {
                    that.display('checkout');
                })
				.fail(function (data) {
		            var m = data && (data.ErrorMessage || data.NotificationMessage);
					if (m) {
						alert(m);
						that.display('checkout');
					}
                });
        },

        resendCode: function () {
            this.model.verifyPhoneNumber();
        },

        beforeShow: function () {
            this.render();
        },

        afterHide: function () {
            this.model.cancel();
        },

        render: function () {
            this.$codeErrorMessage.text(this.model.get('CodeErrorMessage') || '');
            this.$phoneErrorMessage.text(this.model.get('PhoneErrorMessage') || '');
            this.$countryCode.text(this.model.getCountryCode());
        }
    });
})(BaseView, InputFieldView);